import { apiUrl } from 'src/app/data/schema/api-url';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { SnackbarService } from 'src/app/data/service/snackbar.service';
import { AUTH } from 'src/app/constant/constant';
import { NccSpinner } from 'src/app/data/service/nccSpinner.service';
import { SysTemConfigService } from 'src/app/data/service/system-config.service';
import { UserService } from 'src/app/data/service/user.service';
import { RegionService } from 'src/app/data/service/region.service';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs';
import { DomainContextService } from 'src/app/core/service/domain-context.service';

@Injectable({
  providedIn: 'root',
})

export class AuthService {
  constructor(public http: HttpClient,
    private router: Router,
    private spinner: NccSpinner,
    private snackbar: SnackbarService,
    private system: SysTemConfigService,
    private userService: UserService,
    private regionService: RegionService,
    private domainContext: DomainContextService) {}
  

  // ----------------------Don't delete (TRIBAO) ---------------------
  async gettoken(url, requestBody) {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Basic d2Vic2l0ZTpWbnB0QDEyMyE=');
    headers.append('Access-Control-Allow-Origin', '*');
    var formdata = new FormData();
    formdata.append('grant_type', 'password');
    formdata.append('username', requestBody.tenDangNhap);
    formdata.append('password', requestBody.matKhau);
    return await this.http.post<any>(url, formdata, { headers: headers }).toPromise();
  }

  async checkingPasswordExpire() {
    return await this.http.get<any>(apiUrl.nguoiDung.checkingPasswordExpireUrl, { headers: this.getHeader() }).toPromise();
  }

  async getCurrentUser(urlGetChiTiet) {
    return await this.http.get<any>(urlGetChiTiet + apiUrl.nguoiDung.userDetail, { headers: this.getHeader() }).toPromise();
  }

  getHeader() {
    const token = localStorage.getItem(AUTH.TOKEN_KEY);
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + token);
    headers = headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    return headers;
  }

  /**
   * @auth hangdtt
   * Điều chỉnh API login
   */
  private subscription: Subscription[] = [];

  async login(url, urlGetChiTiet, requestBody) {
    try {
        let data = await this.gettoken(url, requestBody);
        localStorage.setItem(AUTH.TOKEN_KEY, data.access_token);
        let checkingPasswordExpire = {
            status: 1,
            current_user: "admmin"
        };
        // let checkingPasswordExpire = await this.checkingPasswordExpire();
        if (checkingPasswordExpire) {
            if (checkingPasswordExpire.status == 0) {
                this.snackbar.openSnackBar('Mật khẩu đã hết hạn', '', '', 'error_notification');
                this.spinner.hide();
            } else {
                let userInfo = await this.getCurrentUser(urlGetChiTiet);
                if (userInfo) {
                  localStorage.setItem(AUTH.USER_INFO_KEY, JSON.stringify(userInfo));
                  var listNhomQuyen = userInfo.danhSachNhomQuyen.map(p => p.KY_HIEU);
                //   await this.setLocalStorage(userInfo);
                  await this.system.getSystemConfig("", userInfo.maTinhBhxh, listNhomQuyen[0]);
                  if (this.domainContext.applyLaoCaiFlow()) {
                    await this.getMenu();
                  }
                }
                this.router.navigate(['/']);
                this.snackbar.openSnackBar('Đăng nhập thành công', '', '', 'success_notification');
            }
        }
    } catch (e) {
        this.snackbar.openSnackBar('Đăng nhập không thành công. Vui lòng kiểm tra tên đăng nhập và mật khẩu!', '', '', 'error_notification');
    }
  }

  match(roleUser: any[], role) {
    let countSubmenu = 0;
    roleUser.forEach((roU) => {
        if (role === roU.KY_HIEU) {
            countSubmenu = countSubmenu + 1;
        }
    });
    if (countSubmenu > 0) {
        return true;
    } else {
        return false;
    }
  }

  listMenu;
  async getMenu() {
    this.listMenu = await this.userService.getMenu().toPromise();
    localStorage.setItem('menu', JSON.stringify(this.listMenu));
  }

  tinhList;
  async apiGetTinhThanh() {
    this.tinhList = await this.regionService.getTinh().toPromise();
  }

  xaList;
  async apiGetPhuongXa(maTinh) {
    this.xaList = await this.regionService.getXa(maTinh).toPromise();
  }

  thonList;
  async apiGetThonAp(maTinh, maXa) {
    this.thonList = await this.regionService.getThon(maTinh, maXa).toPromise();
  }

  async initAuth(user) {
    await this.apiGetTinhThanh();
    if (user.maTinhBhxh) await this.apiGetPhuongXa(user.maTinhBhxh);
    else this.xaList = [];
    if (user.maXaPhuongBhxh) await this.apiGetThonAp(user.maTinhBhxh, user.maXaPhuongBhxh);
    else this.thonList = [];
  }

  async setLocalStorage(user) {
    await this.initAuth(user);
    let region = {
      dmTinh: this.tinhList,
      dmXa: this.xaList,
      dmThon: this.thonList,
    }
    localStorage.setItem('region', JSON.stringify(region));
  }
}